import * as React from "react";

import { valueIsDefined } from "lib/helpers";

interface Props {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencies: any[];
}

export function Optional(props: Props) {
  /**
   * Children will only be rendered if all dependencies are defined.
   * Usage:
   * <Optional
   *    dependencies={[nullableFields]}
   * >
   *    <foo />
   * </Optional>
   */
  const { children, dependencies } = props;

  return <>{dependencies.every(x => valueIsDefined(x)) && children}</>;
}
